import React from 'react'
import { DatePicker } from '@material-ui/pickers'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

import SetWeekDialog from 'components/SetWeekDialog'

class ForecastFarmPicker2 extends React.Component {
  render() {
    const props = this.props
    
    return (
      <React.Fragment>
        {props.forecastFarmPickerOpen && props.forecastFarmsOptions && (
          <Dialog open={true} onClose={props.closeForecastFarmPicker} fullScreen={true}>
            <div style={{height: 30}}></div>
            <DialogTitle id="confirmation-dialog-title">Elegir finca</DialogTitle>
            <DialogContent>
              <MenuList style={{ marginTop: -10, marginBottom: 10 }}>
                {props.forecastFarmsOptions.map(item => <MenuItem onClick={() => props.changeForecastSelectedFarm(item)}>{item.label}</MenuItem>)}
              </MenuList>
            </DialogContent>
            <DialogActions>
              <Button onClick={props.closeForecastFarmPicker}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        )}
      </React.Fragment>
    )
  }
}

const styles = {
  datePicker: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial' !important",
  },
}

export default withStyles(styles)(ForecastFarmPicker2)


// WEBPACK FOOTER //
// ./src/components/ForecastFarmPicker.js